import React from 'react';
import Responsive from 'react-responsive';

let desktopBreak = 1000;
let largeDesktop = 1600;

// Desktop, tablet and mobile setup
export const LargeDesktop = props => <Responsive values={{ width: 1600 }}{...props} minWidth={largeDesktop} children={props.children} />;
export const Desktop = props => <Responsive values={{ width: 1600 }}{...props} minWidth={desktopBreak} children={props.children} />;
export const Tablet = props => <Responsive values={{ width: 1600 }}{...props} minWidth={768} maxWidth={desktopBreak} children={props.children} />;
export const Mobile = props => <Responsive values={{ width: 1600 }}{...props} maxWidth={768} children={props.children} />;
export const MobileTablet = props => <Responsive values={{ width: 1600 }}{...props} maxWidth={desktopBreak} children={props.children} />;


// WEBPACK FOOTER //
// ./src/Responsive.js